// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__35dCP","label":"CategoryService_label__2aeKE","location":"CategoryService_location__3Yb6a"};